import { BACKEND } from "../variables";
import axios from "axios";

const GET_EXPENSES_BY_HOUSE_URL = BACKEND + "/expenses/getExpensesByHouse";
const GET_EXPENSE_BY_ID_URL = BACKEND + "/expenses/getExpenseById";
const CREATE_EXPENSE_URL = BACKEND + "/expenses/create";
const UPDATE_EXPENSE_URL = BACKEND + "/expenses/update";
const DELETE_EXPENSE_URL = BACKEND + "/expenses/delete";

const expenses = {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ["GET_EXPENSES"]: (state, payload) => {
      return axios({
        url: GET_EXPENSES_BY_HOUSE_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_EXPENSE_BY_ID"]: (state, payload) => {
      return axios({
        url: GET_EXPENSE_BY_ID_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["CREATE_EXPENSE"]: (state, payload) => {
      return axios({
        url: CREATE_EXPENSE_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["UPDATE_EXPENSE"]: (state, payload) => {
      return axios({
        url: UPDATE_EXPENSE_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["DELETE_EXPENSE"]: (state, payload) => {
      return axios({
        url: DELETE_EXPENSE_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
  },
  modules: {},
};

export default expenses;

